import { render, staticRenderFns } from "./EditAddressForm.vue?vue&type=template&id=9fa2805a&scoped=true"
import script from "./EditAddressForm.vue?vue&type=script&lang=js"
export * from "./EditAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa2805a",
  null
  
)

export default component.exports